const CURRENCY = require("./currency.json");

export const CURRENCY_ATTRIBUTE = {
  DC_SYMBOL: "dc_symbol",
  SYMBOL: "symbol",
  CODE: "code",
  SYMBOL_NATIVE: "symbol_native",
  DECIMALS: "decimals",
  PRECISION: "precision"
}

/** @returns {{ dc_symbol, symbol, code,  symbol_native, decimals, precision }} */
export function getCurrencyItem({ source, by = CURRENCY_ATTRIBUTE.CODE, attribute, defaultValue = {} } = {}) {
  if (!source || typeof source !== "string") {
    return getValueByField(defaultValue, attribute);
  }

  source = source.toUpperCase();

  let result = getCurItemByField(source, by, by !== CURRENCY_ATTRIBUTE.CODE);

  if (!result) result = defaultValue;

  return getValueByField(result, attribute);
}

export function getCurItemByField(source, field, runAll = true) {
  if (field === CURRENCY_ATTRIBUTE.CODE) {
    return CURRENCY[source] || {};
  }
  // Get currency item other code field
  let result = [];

  const arr = Object.keys(CURRENCY);
  for (let i = 0; i < arr.length; i++) {
    const key = arr[i];
    if (source.includes(CURRENCY[key][field])) {
      if (!runAll) {
        return CURRENCY[key];
      }
      result.push(CURRENCY[key]);
    }
  }
  if (result.length === 1) {
    return result[0];
  }

  return {};
}


function getValueByField(result, field) {
  return field ? (result[field] || "") : result;
}

export function getSymbolCurrency(source) {
  return getCurrencyItem({ source: source, attribute: CURRENCY_ATTRIBUTE.DC_SYMBOL });
}

export function getPriceText(price = 0, currency, locales) {
  let currencyItem = getCurrencyItem({ source: currency }) || {};
  let symbol = currencyItem.dc_symbol || "", precision = currencyItem.precision !== undefined ? currencyItem.precision : 2;
  let zeroNum = precision ? Number(0).toFixed(precision) : 0;

  if (isEmptyNumber(price)) return genPriceText(zeroNum, symbol);

  try {
    const formatter = new Intl.NumberFormat(locales || 'en-US', {
      currency: currency || 'VND',
      minimumFractionDigits: precision,
    });
    if (typeof price === "string") {
      if (Number.isNaN(price * 1)) {
        price = priceParse(price);
      } else {
        price = price * 1;
      }
    }
    const result = formatter.format(price);
    return genPriceText(result.indexOf("NaN") !== -1 ? zeroNum : result, symbol);
  } catch (error) {
    console.error(error);
    return genPriceText(zeroNum, symbol);
  }
}

export function isEmptyNumber(num) {
  return !num || num === "null" || num === "undefined" || num === "0" || Number.isNaN(num) || num * 1 === 0 || (typeof (num) !== "number" && typeof (num) !== "string");
}

function genPriceText(price = 0, symbol = "") {
  return `<span class="num"><span class="unit">${symbol}</span>${price}</span>`;
}

export function stringToPrice(string) {
  let data = (string + "").replace(/ /g, '').toLowerCase();

  data = priceSplitPrice(data);

  data = priceParse(data);

  return data;
}

export const priceSplitPrice = (source = "") => {
  if (typeof source !== "string") {
    return "";
  }
  const arr = source.match(/[\d,.]+/g);
  if (arr && arr.length > 0) {
    return arr[arr.length - 1];
  }

  return "";
}

export const priceParse = (source = "") => {
  if (!source) return 0;
  if (typeof source === "number") return source;
  const countDot = (source.match(/\./g) || []).length;
  if (countDot > 1) {
    source = source.replace(/\./g, '').replace(/,/g, '.');
    return +source || 0;
  }
  source = source.replace(/,/g, '');
  return +source || 0;
}

export function convertCurrency(source, currency, locales) {
  try {
    // var formatter = new Intl.NumberFormat(locales || 'en-US', {
    //   style: 'currency',
    //   currency: currency || 'VND',
    // });
    // const result = formatter.format(source);
    // return result.indexOf("NaN") !== -1 ? "" : result;

    let result = convertCurrencyNoSymbol(source, currency, locales);
    return result ? getSymbolCurrency(currency) + result : "";
  } catch (error) {
    console.error(error)
    return source;
  }
}

export function convertCurrencyNoSymbol(source, currency, locales) {
  try {
    const formatter = new Intl.NumberFormat(locales || 'en-US', {
      currency: currency || 'VND',
    });
    const result = formatter.format(source);
    return result.indexOf("NaN") !== -1 ? "" : result;
  } catch (error) {
    console.error(error)
    return "";
  }
}

export function convertCurrencyList(list, currentCur) {
  let result = [], sortedList = [];
  if (Array.isArray(list) && list.length > 0) {
    if (currentCur) {
      sortedList[0] = currentCur;
      list.forEach(element => {
        if (element !== currentCur) sortedList.push(element);
      });
    } else {
      sortedList = list;
    }
    result = sortedList.map(item => {
      let symbol = getSymbolCurrency(item);
      return {
        value: (item || "").toUpperCase(),
        label: `${symbol ? symbol + " - " : ""}` + item
      }
    })
  }
  return result;
}

export function autoFormatMoneyInput(e) {
  /** @type {String} */
  let value = e.target.value;
  const originalLen = value.length;
  let caretPos = e.target.selectionStart;
  value = value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
  if (!value.length) {
    e.target.value = value;
    return value;
  }
  if (value.indexOf(".") !== -1) {
    const arr = value.split(".");
    value = `${convertCurrencyNoSymbol(arr[0])}.${arr[1] ?? ""}`;
  } else {
    value = convertCurrencyNoSymbol(value);
  }
  e.target.value = value;
  const updatedLen = value.length;
  caretPos = updatedLen - originalLen + caretPos;
  e.target.setSelectionRange(caretPos, caretPos);
  return value;
}